export enum DevsiteCookies {
  // octo token
  WDAY_ACCESS_TOKEN = 'wday-access-token',
  TENANT_AUTH_TOKEN = 'tenant-access-token',
  PAGE_INSPECTOR_ENABLED = 'page-inspector-enabled',
  WCP_ORG_UUID = 'wcp-org-uuid',
  QUICK_VIEW_COPILOT_GENERATE_ID = 'quickview-copilot-generate-id',
  // for showing internal features
  BUILD_SELECT = 'build-select',
  FB_XSRF_TOKEN = 'XSRF-TOKEN', // Used by Spring in Orchestration/Flow Builder Server
  AB_XSRF_TOKEN = 'AB-XSRF-TOKEN', // Used by Spring in Devtools/App Builder Server
  // for tracking metrics with an id shared with digital.workday.com
  ANALYTICS_ID = 'analytics-id',
}

export const doNotRemoveOnLogout = [
  DevsiteCookies.BUILD_SELECT,
  DevsiteCookies.WCP_ORG_UUID,
  DevsiteCookies.ANALYTICS_ID,
];

// cookies that are suffixed with the org UUID (so that tokens valid for one org don't get used in another)
export enum DevsiteOrgCookies {
  QUICK_VIEW_TENANT_AUTH_TOKEN = 'quickview-tenant-access-token',
  DEPLOY_TENANT_AUTH_TOKEN = 'deploy-tenant-access-token',
  TENANT_AUTH_TOKEN = DevsiteCookies.TENANT_AUTH_TOKEN,
}

export const BUILD_SELECT_INTERNAL = 'internal';
